import { FormattedMessage } from 'react-intl';
import { ReactComponent as BatteryIcon } from '../icons/item-icons/battery-secondary.svg';
import { ReactComponent as CalendarIcon } from '../icons/calendar.svg';
import TabularPage from '../components/tabs/TabularPage';
import BiddingStrategies from './BiddingStrategies';
import { BIDDING_STRATEGIES_ROUTES } from 'constants/routes';

const tabsRoutes = [
    {
        // First tab is not an autoform
        // It is a custom component and might have selected item <Route path={`${path}/:strategyId`}>
        name: <FormattedMessage id="batteries_admin_bidding_strategies" />,
        relativePath: BIDDING_STRATEGIES_ROUTES.STRATEGIES,
        component: <BiddingStrategies />,
    },
    {
        name: <FormattedMessage id="batteries_admin_periods" />,
        relativePath: BIDDING_STRATEGIES_ROUTES.PSBATADMINPERIODS,
        itemIcon: CalendarIcon,
        autoformIcon: CalendarIcon,
    },
    {
        name: <FormattedMessage id="batteries_admin_products" />,
        relativePath: BIDDING_STRATEGIES_ROUTES.PSBATADMINPRODUCTS,
        itemIcon: BatteryIcon,
        autoformIcon: BatteryIcon,
    },
    {
        name: <FormattedMessage id="batteries_admin_day_types" />,
        relativePath: BIDDING_STRATEGIES_ROUTES.PSBATADMINDAYTYPES,
        itemIcon: BatteryIcon,
        autoformIcon: BatteryIcon,
    },
];

const BiddingStrategiesAdminPage = () => {
    return <TabularPage routes={tabsRoutes} />;
};

export default BiddingStrategiesAdminPage;
